import { AST } from '../../../ast';
import { Operator } from '../../lex/tokens';

export const INFIX_OPERATOR_TO_FC: Partial<
  Record<Operator, AST.FunctionIdentifier>
> = {
  '!=': 'neq',
  '&&': 'and',
  '*': 'mul',
  '+': 'add',
  '-': 'sub',
  '/': 'div',
  '<': 'lt',
  '<=': 'lte',
  '==': 'eq',
  '>': 'gt',
  '>=': 'gte',
  '??': 'coalesce',
  '^': 'to_the_power_of',
  '||': 'or',
};

export const FC_TO_INFIX_OPERATOR: Partial<
  Record<AST.FunctionIdentifier, Operator>
> = Object.fromEntries(
  Object.entries(INFIX_OPERATOR_TO_FC).map(([op, name]) => [name, op])
);
